import React, { useEffect } from "react";
import { connect } from "react-redux";
import { changeReferralStatus } from "../../../redux/Actions/ReferralActions";
import DeleteModal from "../../Modal/DeleteModal";

const ActivateReferral = (props) => {
  const { changeReferralStatus, id, isChanging, changeSuccess } = props;

  useEffect(
    () => {
      if (changeSuccess) {
        props.closeModal();
      }
    }, // eslint-disable-next-line
    [changeSuccess]
  );

  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Activate this referral?"}
      width={"463px"}
      text={"Activate"}
      onClick={() => changeReferralStatus(id)}
      disabled={isChanging}
      isLoading={isChanging}
      activate={true}
      loadingText={"Activating..."}
      children={
        "Once you activate this referral, this referral would be active. Activate referral?"
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isChanging: state.referrals.isChanging,
  changeSuccess: state.referrals.changeSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  changeReferralStatus: (id) => dispatch(changeReferralStatus(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivateReferral);
